import React, { useEffect, useRef, memo } from "react";
import { Chart } from "chart.js/auto";

const SharedPieChart = memo(({
  firstLabel,
  secondLabel,
  firstValue,
  secondValue,
  firstColor = "#28a745",
  secondColor = "#dc3545",
  title = "الجدول البياني"
}) => {
  const canvasRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    // Destroy previous chart instance
    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }

    // Create new chart
    chartInstanceRef.current = new Chart(canvasRef.current, {
      type: 'pie',
      data: {
        labels: [firstLabel, secondLabel],
        datasets: [{
          data: [parseFloat(firstValue), parseFloat(secondValue)],
          backgroundColor: [firstColor, secondColor],
          borderColor: ["#fff", "#fff"],
          borderWidth: 2,
        }],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
      }
    });

    // Cleanup on unmount
    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, [firstLabel, secondLabel, firstValue, secondValue, firstColor, secondColor]);

  return (
    <div className="calculatorStyle">
      <h2 
        className="p-3 mb-2 bg-success text-white" 
        style={{ fontSize: "16px" }}
      >
        {title}
      </h2>
      <div style={{ maxWidth: "300px", margin: "20px auto" }}>
        <canvas ref={canvasRef}></canvas>
      </div>
    </div>
  );
});

SharedPieChart.displayName = "SharedPieChart";

export default SharedPieChart;